import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Rodeo } from '../../../../model/rodeo';
import { PrintService } from '../../../../services/print-service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'page-exhibitions-report',
	templateUrl: 'report-exhibitions.html'
	
})
export class ExhibitionsReport implements OnInit, OnDestroy {
    @Input('rodeo') rodeo: Rodeo;

    printing: boolean;
    nameOrder: boolean;

    dataLoaded: boolean;

    exhibitions: any[];

    private sub: Subscription;

    constructor(private printService: PrintService) { }

    ngOnInit() {
        this.load();
        this.sub = this.printService.printing.subscribe(printing => this.printing = printing);
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    load() {
        this.exhibitions = [];

        for (let exhibition of this.rodeo.exhibitions) {
            if (this.exhibitions.filter(x => x.name == exhibition.name && x.date == exhibition.date).length == 0)
                this.exhibitions.push({ id: exhibition.id, name: exhibition.name, date: exhibition.date, realDate: new Date(exhibition.date), runs: null});        
        }

        this.exhibitions.sort((a, b) => {
            if (a.realDate < b.realDate)
                return -1;
            else if (a.realDate > b.realDate)
                return 1;
            
            if (a.name < b.name)
                return -1;
            else if (a.name > b.name)
                return 1;

            return 0;
        })

        this.rodeo.rodeoEvents.flatMap(x => x.registrations).forEach((registration) => {
            if (registration.status !== "TurnedOut") {
                registration.exhibitions.forEach((exhibition) => {
                    let selectedExhibition = this.exhibitions.filter(x => x.id == exhibition.exhibitionId)[0]
    
                    if (selectedExhibition) {
                        if (!selectedExhibition.runs)
                            selectedExhibition.runs = [];
    
                        let exhibitionRun:any = {};
                        exhibitionRun.rider = registration.contestantOne.firstName + " " + registration.contestantOne.lastName;
                        exhibitionRun.firstname = registration.contestantOne.firstName;
                        exhibitionRun.lastName = registration.contestantOne.lastName;
    
                        for (let i = 0; i < exhibition.entryCount; i++) {
                            selectedExhibition.runs.push(exhibitionRun);
                        }
                    }
                })
            }
        });

        this.sortExhibitionRuns();
        
        this.dataLoaded = true;
    }

    sortExhibitionRuns() {
        if (!this.exhibitions || this.exhibitions.length == 0) return;

        if (!this.nameOrder) {
            this.exhibitions.forEach((exhibition) => {
                if (exhibition.runs && exhibition.runs.length > 0)
                    exhibition.runs = exhibition.runs.sort((a, b) => 0.5 - Math.random());
            })
        } else {
            this.exhibitions.forEach((exhibition) => {
                if (exhibition.runs && exhibition.runs.length > 0)
                    exhibition.runs.sort((a, b) => {
                        if (a.firstName < b.firstName)
                            return -1;
                        else if (a.firstName > b.firstName)
                            return 1;

                        if (a.lastName < b.lastName)
                            return -1;
                        else if (a.lastName > b.lastName)
                            return 1;
                    });
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-exhibitions.ts